export const SAMPLE_SECTORS = [
  { value: "HP", label: "Histopatolog\u00eda" },
  { value: "BG", label: "Bioqu\u00edmica General" },
  { value: "PA", label: "Parasitolog\u00eda" },
  { value: "BM", label: "Biolog\u00eda Molecular" },
  { value: "BAC", label: "Bacteriolog\u00eda" },
  { value: "PT", label: "Toxicolog\u00eda" },
  { value: "ITS", label: "Infecciones de Transmisi\u00f3n Sexual" },
  { value: "SER", label: "Serolog\u00eda" },
  { value: "PACK_TORO", label: "Pack toro" },
  { value: "OTR", label: "Otros" },
];
